module.exports = __webpack_public_path__ + "img/inventory_2_black_24dp.c49ff29d.svg";